import Typography from "@mui/material/Typography";
import {
  APP_COLORS,
  ENUM_QUALIFY_QUESTION_TYPES,
  VIEW_MODE,
} from "../../enums";
import {
  AppTextField,
  ChipTextField,
  DefaultButton,
} from "../../components/form";
import { Box, Card, Grid, Stack } from "@mui/material";
import Flexbox from "../../components/layouts/Flexbox";

export default function ProjectQuestions({
  answers,
  mode,
  questions,
  handleOnAnwerChange,
}) {
  const isEditMode = mode === VIEW_MODE.EDIT;
  const onYesNoSelect = (name, value) => {
    handleOnAnwerChange({
      target: {
        name: name,
        value,
      },
    });
  };

  const renderAnswerInput = (que) => {
    switch (questions?.[que]?.q?.type) {
      case ENUM_QUALIFY_QUESTION_TYPES.BOOLEAN:
        return (
          <Stack direction={"row"} gap={1}>
            <DefaultButton
              size="small"
              onClick={() => onYesNoSelect(que, "Yes")}
              sx={{
                border: `1px solid ${answers[que] === "Yes" ? APP_COLORS.primary : APP_COLORS.grey
                  }`,
                backgroundColor:
                  answers[que] === "Yes"
                    ? APP_COLORS.primary
                    : APP_COLORS.white,
                color:
                  answers[que] === "Yes"
                    ? APP_COLORS.white
                    : APP_COLORS.primary,
                "&:hover": {
                  backgroundColor: APP_COLORS.primary,
                  color: APP_COLORS.white,
                },
              }}
            >
              Yes
            </DefaultButton>
            <DefaultButton
              size="small"
              onClick={() => onYesNoSelect(que, "No")}
              sx={{
                border: `1px solid ${answers[que] === "No" ? APP_COLORS.error : APP_COLORS.grey
                  }`,
                backgroundColor:
                  answers[que] === "No" ? APP_COLORS.error : APP_COLORS.white,
                color:
                  answers[que] === "No" ? APP_COLORS.white : APP_COLORS.error,
                "&:hover": {
                  backgroundColor: APP_COLORS.error,
                  color: APP_COLORS.white,
                },
              }}
            >
              No
            </DefaultButton>
          </Stack>
        );
      case ENUM_QUALIFY_QUESTION_TYPES.MULTI_SELECT:
        return (
          <ChipTextField
            inputProps={{
              id: que,
              value: answers[que] || "",
              name: que,
              onChange: handleOnAnwerChange,
              variant: "outlined",
              multiline: true,
            }}
            options={questions?.[que]?.q?.options || []}
            rootProps={{ margin: "dense" }}
            freeSolo={false}
            textFieldVariant={"outlined"}
            errorProps={{
              error: "",
              showError: true,
            }}
          />
        );

      default:
        return (
          <AppTextField
            key={`form-${questions?.[que]?.q?.question}`}
            rootProps={{ margin: "dense", sx: { mt: 0, mb: 0 } }}
            inputProps={{
              id: que,
              value: answers[que] || "",
              name: que,
              onChange: handleOnAnwerChange,
              variant: "outlined",
              multiline: true,
              rows: 3,
            }}
            labelProps={{
              inputLabel: "",
              label: "",
            }}
            errorProps={{
              error: "",
              helperText: "",
            }}
          />
        );
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Stack>
          <Typography variant="heading6-helveticaNeue-medium">
            Questions:
          </Typography>
          {isEditMode && (
            <Typography
              variant="small-ibmPlexMono"
              color={APP_COLORS.grey}
              borderBottom={`1px solid ${APP_COLORS.greyLight4}`}
              py={.5}
            >
              Please provide answers to all questions below.
            </Typography>
          )}
        </Stack>
      </Grid>
      <Grid item xs={12}>
        {questions
          ? Object.keys(questions)
            ?.sort()
            ?.map((que, index) => (
              <Stack
                component={isEditMode ? Box : Card}
                my={2}
                bgcolor={isEditMode ? APP_COLORS.white : APP_COLORS.greyLight}
                p={0}
                borderRadius={4}
                gap={isEditMode ? 2 : 0}
              >
                <Flexbox
                  alignItems="center"
                  gap={1}
                  minHeight={isEditMode ? "auto" : 70}
                  p={isEditMode ? 0 : 2}
                >
                  <Typography
                    variant="body-ibmPlexMono"
                    color={APP_COLORS.white}
                    bgcolor={APP_COLORS.secondary}
                    borderRadius={28}
                    width={33}
                    height={26}
                    component={Flexbox}
                    alignItems="center"
                    justifyContent="center"
                    padding={"2px 8px"}
                  >
                    Q{index + 1}
                  </Typography>
                  <Typography variant="body-helveticaNeue-medium">
                    {questions?.[que]?.q?.question}
                  </Typography>
                </Flexbox>
                <Flexbox
                  alignItems="center"
                  bgcolor={APP_COLORS.white}
                  p={isEditMode ? 0 : 2}
                  borderRadius={2}
                  height={"auto"}
                >
                  {mode === VIEW_MODE.VIEW ? (
                    <Typography variant="small" color={"text.secondary"}>
                      {Array.isArray(answers[que])
                        ? answers[que].join(", ")
                        : answers[que] || "N/A"}
                    </Typography>
                  ) : (
                    <Box pl={5} width={"100%"}>
                      {renderAnswerInput(que)}
                    </Box>
                  )}
                </Flexbox>
              </Stack>
            ))
          : ""}
      </Grid>
    </Grid>
  );
}
